import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../../../components/BaseButton";
import BaseIcon from "../../../../components/BaseIcon";
import "./style.scss";
import useBrowserStorage from "../../../../hooks/useBrowserStorage";
import ROUTES from "../../../../utils/routes";
import resultCardImage from "../../../../assets/images/shop/result_card.png";
import { shopStore } from "../../../../store/Shop";
import useModalActions from "../../../../hooks/useModalActions";
import { MODAL_TYPES } from "../../../../utils/emitter";
import Game from "../../../../store/Game";
import Pricing from "../../../../store/Pricing";
import PersonalAccount from "../../../../store/PersonalAccount";
import { userFinishedExtended } from "../../../../utils/extendedProgress";

export default observer(function Results({ isDemo }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getItem } = useBrowserStorage();
  const { openModal } = useModalActions();
  const game = Game.game;

  useEffect(() => {
    Pricing.fetch();
  }, []);

  return (
    <div className="result-wrapper">
      <div
        className="result-wrapper__title neon-text"
        data-text={t("demo_result_test_page.results.title")}
      >
        {t("demo_result_test_page.results.title")}
      </div>
      <div className="result-par-1">
        <div>{t("demo_result_test_page.results.paragraph1.text1")}</div>
        <div>{t("demo_result_test_page.results.paragraph1.text2")}</div>
      </div>
      <div className="result-par-2">
        <div>{t("demo_result_test_page.results.paragraph2.text1")}</div>
        <ul>
          <li>
            <BaseIcon name="check_purple" />
            {t("demo_result_test_page.results.paragraph2.text2")}
          </li>
          <li>
            <BaseIcon name="check_purple" />
            {t("demo_result_test_page.results.paragraph2.text3")}
          </li>
          <li>
            <BaseIcon name="check_purple" />
            {t("demo_result_test_page.results.paragraph2.text4")}
          </li>
        </ul>
        <div>{t("demo_result_test_page.results.paragraph2.text5")}</div>
      </div>
      <div className="result-par-3">
        <div>{t("demo_result_test_page.results.paragraph3.text1")}</div>
        <ul>
          <li>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <BaseIcon className="result-par-3__icon" name="check_purple" />
            {t("demo_result_test_page.results.paragraph3.text2")}
          </li>
          <li>
            <BaseIcon className="result-par-3__icon" name="check_purple" />
            &nbsp;&nbsp;&nbsp;&nbsp;
            {t("demo_result_test_page.results.paragraph3.text3")}
          </li>
          <li>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <BaseIcon className="result-par-3__icon" name="check_purple" />
            {t("demo_result_test_page.results.paragraph3.text4")}
          </li>
        </ul>
        <div>{t("demo_result_test_page.results.paragraph3.text5")}</div>
      </div>
      <div className="result-par-4">
        <div className="result-par-4__title">
          <BaseIcon name="arrow_right" />
          {t("demo_result_test_page.results.paragraph4.text1")}
        </div>
        <ul>
          <li className="result-par-4__text-item">
            <div className="result-par-4__disc-item" />
            {t("demo_result_test_page.results.paragraph4.text2")}
          </li>
          <li className="result-par-4__text-item">
            <div className="result-par-4__disc-item" />
            {t("demo_result_test_page.results.paragraph4.text3")}
          </li>
          <li className="result-par-4__text-item">
            <div className="result-par-4__disc-item" />
            {t("demo_result_test_page.results.paragraph4.text4")}
          </li>
          <li className="result-par-4__text-item">
            <div className="result-par-4__disc-item" />
            {t("demo_result_test_page.results.paragraph4.text5")}
          </li>
        </ul>
      </div>
      <div className="result-blocks">
        <div className="result-blocks__title">
          {t("demo_result_test_page.results.zone_blocks.title")}
        </div>
        <div className="result-blocks__blocks">
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>1.</div>
              {t("demo_result_test_page.results.zone_blocks.text1")}
            </div>
          </div>
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>2.</div>
              {t("demo_result_test_page.results.zone_blocks.text2")}
            </div>
          </div>
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>3.</div>
              {t("demo_result_test_page.results.zone_blocks.text3")}
            </div>
          </div>
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>4.</div>
              {t("demo_result_test_page.results.zone_blocks.text4")}
            </div>
          </div>
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>5.</div>
              {t("demo_result_test_page.results.zone_blocks.text5")}
            </div>
          </div>
          <div className="result-blocks__block-wrapper">
            <div className="result-blocks__block">
              <div>6.</div>
              {t("demo_result_test_page.results.zone_blocks.text6")}
            </div>
          </div>
        </div>
      </div>
      <div className="result-par-5">
        <div>{t("demo_result_test_page.results.paragraph5.text1")}</div>
        <ul>
          <li className="result-par-5__item">
            <div className="result-par-5__disc-item" />
            {t("demo_result_test_page.results.paragraph5.text2")}
          </li>
          <li className="result-par-5__item">
            <div className="result-par-5__disc-item" />
            {t("demo_result_test_page.results.paragraph5.text3")}
          </li>
          <li className="result-par-5__item">
            <div className="result-par-5__disc-item" />
            {t("demo_result_test_page.results.paragraph5.text4")}
          </li>
        </ul>
      </div>
      {/* Figma 7464-38920: лиловый слоган между двумя линиями перед кнопкой */}
      {!isDemo ? (
        <div className="result-tool-tagline">
          <p className="result-tool-tagline__text">
            {t("demo_result_test_page.results.subtitle")}
          </p>
        </div>
      ) : null}
      {isDemo ? (
        <div className="result_subtitles">
          <div>{t("demo_result_test_page.results.subtitle")}</div>
        </div>
      ) : null}
      <div className="result-buy">
        {isDemo ? (
          // ТЗ п.7.2: анкета откровений в итогах — 2 кнопки в ряд
          // «Купить 49$/4900₽» и «4900 баллов»
          <div className="result-buy__loyalty">
            <BaseButton
              onClick={() =>
                navigate(ROUTES.PAYMENT_PAGE, {
                  state: { productType: "GAME" },
                })
              }
            >
              {t("loyalty.buy_for", { price: Pricing.format("GAME") })}
            </BaseButton>
            <BaseButton
              onClick={() =>
                openModal(MODAL_TYPES.BUY_PRODUCT, {
                  productType: "GAME",
                  variant: "anketa",
                  gameId: game?.id,
                })
              }
            >
              {t("loyalty.buy_for_points", {
                points: Pricing.get("GAME")?.points ?? 4900,
              })}
            </BaseButton>
          </div>
        ) : (
          <BaseButton
            onClick={() =>
              // item 17.09: гейт «инструкция не прочитана → страница продажи» снят —
              // раздел анкеты всегда выглядит одинаково
              navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)
            }
          >
            {t("demo_result_test_page.results.insight")}
          </BaseButton>
        )}
      </div>

      {/* Figma 7464-38920: сначала блок магазина, затем блок +57 последним */}
      <div className="result-shop-cta">
        <div className="result-shop-cta__image">
          <img src={resultCardImage} alt="" loading="lazy" />
        </div>
        <div className="result-shop-cta__title">
          {t("shop_modal.results_cta_title")}
        </div>
        <div className="result-shop-cta__desc">
          {t("shop_modal.results_cta_desc")}
        </div>
        <BaseButton
          // item 15: «Смотреть» открывает магазин С ВЫБОРОМ СТРАНЫ (ShopModal),
          // а не редиректит сразу на orion.de. Переход во внешний магазин —
          // уже внутри модалки, после подтверждения страны (там же и аналитика).
          onClick={() => shopStore.open(null)}
          aria-label={t("shop_modal.results_cta_title")}
        >
          {t("shop_modal.watch")}
        </BaseButton>
      </div>

      {/* ТЗ п.9: блок «Ищешь что-то особенное…» + Начать тест (+57) — последним.
          У demo-игры блок скрыт (там продаётся полная игра), КРОМЕ случая, когда
          набор +57 уже разблокирован — иначе купленный набор недостижим из итогов.
          item 15: если текущий игрок УЖЕ прошёл свои +57 — блок неактуален, скрываем
          (остаётся только пока набор ещё не взят/не пройден этим игроком). */}
      {(!isDemo || game?.hasExtendedSet) &&
      !userFinishedExtended(game, PersonalAccount.user?.id) ? (
        <div className="result-ext57-cta">
          <div className="result-ext57-cta__title">
            {t("extended57.offer.title")}
          </div>
          <div className="result-ext57-cta__desc">
            {t("extended57.offer.text")}
          </div>
          <BaseButton
            onClick={() =>
              // item 7: PREMIUM (полная игра) уже включает +57 — ведём проходить,
              // а не предлагаем купить повторно (защита и до накатки бэкфилла)
              game?.hasExtendedSet || game?.type === "PREMIUM"
                ? // item 6: через страницу инструкции. Это тот самый вход с экрана
                  // результатов («Начать тест» под «Ищешь что-то особенное…»), на
                  // который жаловался клиент — он вёл прямо в свайпер без инструкции.
                  navigate(ROUTES.EXTENDED_57_INSTRUCTION_PAGE, {
                    state: { gameId: game?.id },
                  })
                : openModal(MODAL_TYPES.BUY_PRODUCT, {
                    productType: "EXTENDED_57",
                    gameId: game?.id,
                  })
            }
          >
            {t("extended57.start_test_btn")}
          </BaseButton>
        </div>
      ) : null}
    </div>
  );
});
